<template>
  <BaseModalEditCreate
    mode="select"
    :is-modified="false"
    :close-on-outside-click="false"
    max-width="extra"
    :title="$t('salesDocuments.customerModalSelect')"
    @dismiss-changes="onDismiss"
    @save="onSave">
    <template #form>
      <div class="overflow-hidden h-full grid grid-rows-[auto_1fr]">
        <div class="w-full h-full overflow-x-hidden">
          <BaseTable
            v-if="list"
            table-id="sales-modal-costumers"
            :total-records="totalRecords"
            :headers="customerHeaders"
            :list="filteredCustomers"
            only-search
            hide-multiselect-delete
            hide-multiselect-download
            clickable
            disable-multiselect
            :selected-item="selectedCustomer"
            @table-item-clicked="onSelectRow"
            @refresh-data="onRefreshData">
            <template #actions="{ item }: any">
              <div class="flex items-center justify-center w-full">
                <button
                  class="flex items-center justify-center p-[1px] rounded-full bg-slate-200 size-4"
                  @click.prevent="onCustomerInfoClick(item)">
                  <IconInfo class="rounded-full hover:text-theme-600 hove:bg-theme-100"></IconInfo>
                </button>
              </div>
            </template>
          </BaseTable>
        </div>
      </div>
    </template>
  </BaseModalEditCreate>
  <InfoModal
    v-if="showBOCustomerBalanceModal"
    :title="$t('customer.financialInfo')"
    @primary-button-clicked="showBOCustomerBalanceModal = false">
    <template #content>
      <div v-if="htmlContent" v-html="htmlContent" class="overflow-y-auto max-h-72"></div>
      <div v-else>{{ $t('messages.noResultsText') }}</div>
    </template>
  </InfoModal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import BaseModalEditCreate from '@/components/common/BaseModalEditCreate.vue';
import BaseTable from '@/components/common/BaseTable.vue';
import type { TableFilterData } from '@/types/Base';
import type { Customer } from '@/types/Traders';
import IconInfo from '@/assets/icons/IconInfo.vue';
import InfoModal from '@/components/common/InfoModal.vue';
import { getCustomerHtmlTabs } from '@/services/api/traders';

const props = defineProps<{
  list: Customer[];
  totalRecords?: number;
}>();

const emit = defineEmits(['refreshData', 'rowSelect', 'dismiss']);

const filteredCustomers = computed(() => {
  return props.list.filter((x) => !x.deleted);
});

const customerHeaders = [
  { value: 'code', text: 'Code', type: 'text', active: true },
  { value: 'profession', text: 'Profession', type: 'text', active: true },
  { value: 'trader.name', text: 'Trader Name', type: 'text', active: true },
  { value: 'trader.code', text: 'Trader Code', type: 'text', active: true },
  { value: 'trader.taxNumber', text: 'Tax Number', type: 'text', active: true },
  { value: 'trader.address', text: 'Address', type: 'text', active: true },
  { value: 'trader.zipCode', text: 'ZipCode', type: 'text', active: true },
  {
    value: 'defaultPaymentType.name',
    text: 'Default Payment Type',
    type: 'text',
    active: true,
  },
  { value: 'actions', text: '', active: true },
];

const selectedCustomer = ref<Customer>();
function onSelectRow(customer: Customer) {
  selectedCustomer.value = customer;
}

function onRefreshData(data: TableFilterData) {
  let newPageTotal;
  if (props.totalRecords && data.itemsPerPage) {
    newPageTotal = props.totalRecords / data.itemsPerPage;
  }
  if (newPageTotal && data.page && newPageTotal < data.page) data.page = 1;
  emit('refreshData', data);
}

function onDismiss() {
  emit('dismiss');
}

function onSave() {
  if (selectedCustomer.value) emit('rowSelect', selectedCustomer.value);
}

const showBOCustomerBalanceModal = ref(false);
const htmlContent = ref('');
async function onCustomerInfoClick(customer: Customer) {
  if (!customer?.boid) return;
  htmlContent.value = '';
  const htmlTabs = await getCustomerHtmlTabs({
    enumValue: 1,
    customerBoid: customer.boid,
  });
  if (htmlTabs) {
    htmlContent.value = htmlTabs;
  }
  showBOCustomerBalanceModal.value = true;
}
</script>
